// extracted by mini-css-extract-plugin
export default {"iconMenuBtn":"REFRESH_ZAMOWIENIA_BTN_iconMenuBtn__7IlA1","iconMenuBtnDisabled":"REFRESH_ZAMOWIENIA_BTN_iconMenuBtnDisabled__lfytc"};